import { userBaseModel } from './crud';

export * from './types';

export const useUsersById = userBaseModel.fetchById();
export const useUsersByIds = userBaseModel.fetchByIds();
export const useUsersMany = userBaseModel.fetchMany();
export const useUsersCount = userBaseModel.count();
export const useUsersManyInfiniteQuery = userBaseModel.fetchPaginated();
export const useUsersUpdateOne = userBaseModel.edit();
export const useUsersCreateOne = userBaseModel.create();
export const useUsersRemoveOne = userBaseModel.delete();
export const useUsersRemoveByIds = userBaseModel.deleteByIds();

export const useUsersByIdV2 = userBaseModel.fetchByIdV2();
export const useUsersByIdsV2 = userBaseModel.fetchByIdsV2();
export const useUsersManyV2 = userBaseModel.fetchManyV2();
export const useUsersCountV2 = userBaseModel.countV2();
export const useUsersManyInfiniteQueryV2 = userBaseModel.fetchPaginatedV2();
export const useUsersUpdateOneV2 = userBaseModel.editV2();
export const useUsersCreateOneV2 = userBaseModel.createV2();
export const useUsersRemoveOneV2 = userBaseModel.deleteV2();
export const useUsersRemoveByIdsV2 = userBaseModel.deleteByIdsV2();

// New names based on Mongoose queries
export const useUserById = userBaseModel.fetchById();
export const useUserByIds = userBaseModel.fetchByIds();
export const useUserMany = userBaseModel.fetchMany();
export const useUserCount = userBaseModel.count();
export const useUserPagination = userBaseModel.fetchPaginated();
export const useUserUpdateOne = userBaseModel.edit();
export const useUserCreateOne = userBaseModel.create();
export const useUserRemoveOne = userBaseModel.delete();
export const useUserRemoveByIds = userBaseModel.deleteByIds();

export const useUserByIdV2 = userBaseModel.fetchByIdV2();
export const useUserByIdsV2 = userBaseModel.fetchByIdsV2();
export const useUserManyV2 = userBaseModel.fetchManyV2();
export const useUserCountV2 = userBaseModel.countV2();
export const useUserPaginationV2 = userBaseModel.fetchPaginatedV2();
export const useUserUpdateOneV2 = userBaseModel.editV2();
export const useUserCreateOneV2 = userBaseModel.createV2();
export const useUserRemoveOneV2 = userBaseModel.deleteV2();
export const useUserRemoveByIdsV2 = userBaseModel.deleteByIdsV2();
